import React from 'react'
import { styled, Grid as GridBase } from '@mui/material'
import { Typography } from '@chilecompra/react-kit/components'

export const FooterArea = styled('div')`
  background-color: ${props => props.theme.palette.blue[15]};
  max-height: 184px;
  max-height: inherit;
  padding: 40px 20px;

  ${props => props.theme.breakpoints.up('lg')} {
    justify-items: center;
    min-height: 136px;
  }
`

export const Logo = styled('img')`
  height: 44px;
  width: 152.45px;
`

export const GridContainer = styled(props => <GridBase {...props} container />)`
  flex-wrap: ${props => props.flexWrap};
`

export const GridItem = styled(props => <GridBase {...props} item />)`
  display: flex;
  flex-direction: column;
  padding: 0 30px;

  ${props => props.theme.breakpoints.down('xl')} {
    padding: 0;
  }
`

export const HardTitle = styled(props => <Typography {...props} />)`
  ${props => props.theme.breakpoints.down('lg')} {
    padding-top: 45px;
  }
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.white};
  font-family: ${props => props.theme.typography.fontFamily};
  line-height: 14.06px;
  text-align: left;
  text-decoration: underline;

  &:active,
  &:focus,
  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const FacebookIcon = styled('img')`
  color: ${props => props.theme.palette.brand.white};
  height: 21px;
  margin: 2px 4px 2px 0;
  width: 24px;

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const InstagramIcon = styled('img')`
  color: ${props => props.theme.palette.brand.white};
  height: 20px;
  margin: 2px 8px 0px 8px;
  width: 24px;

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const LinkedInIcon = styled('img')`
  color: ${props => props.theme.palette.brand.white};
  height: 20px;
  margin: 2px 8px 2px 8px;
  width: 24px;

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const TwitterIcon = styled('img')`
  color: ${props => props.theme.palette.brand.white};
  height: 18px;
  margin: 2px 8px 2px 8px;
  width: 24px;

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`

export const YouTubeIcon = styled('img')`
  color: ${props => props.theme.palette.brand.white};
  height: 20px;
  margin: 3px 8px 0px 8px;
  width: 20px;

  &:hover {
    color: ${props => props.theme.palette.MP.default.main};
  }
`
